import { render, staticRenderFns } from "./ForumGroup.vue?vue&type=template&id=4b479cb6&"
import script from "./ForumGroup.vue?vue&type=script&lang=js&"
export * from "./ForumGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports